import { render, staticRenderFns } from "./TableRowNumAudiogramsByPhysician.vue?vue&type=template&id=342c835c&lang=pug&"
import script from "./TableRowNumAudiogramsByPhysician.vue?vue&type=script&lang=js&"
export * from "./TableRowNumAudiogramsByPhysician.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('342c835c')) {
      api.createRecord('342c835c', component.options)
    } else {
      api.reload('342c835c', component.options)
    }
    module.hot.accept("./TableRowNumAudiogramsByPhysician.vue?vue&type=template&id=342c835c&lang=pug&", function () {
      api.rerender('342c835c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/benchmarks/table-rows/annually/TableRowNumAudiogramsByPhysician.vue"
export default component.exports